// extracted by mini-css-extract-plugin
module.exports = {"overlay_container":"styles_overlay_container__1aWeD","bounce":"styles_bounce__2B34Y","overlay_Box":"styles_overlay_Box__1gQKd"};